import commonState from 'top20common/distribution/store/state';

export default {
  ...commonState,
  cvPreviewPdfLoadingState: false
};
